module.exports = __webpack_public_path__ + "static/privat-207e2d9c8b6d72ed129a1ab860cfc08c.png";